import { teamContext } from "@redotech/feature-flags-model/context";
import { featureFlag } from "@redotech/openfeature-contracts/flag";

/** Internal Alerts tab for Disputely dispute-alert networks (CDRN/ETHOCA/RDR). */
export const disputeAlertsUiFlag = featureFlag(
  "dispute-alerts-ui",
  teamContext,
).boolean(false);

/** Reclaim impact win-rate chart and KPI badges on the disputes dashboard; Redo staff always see them. */
export const reclaimImpactDashboardFlag = featureFlag(
  "reclaim-impact-dashboard",
  teamContext,
).boolean(false);

/** Internal RESOLVE tab for Disputely deflection (issuer "what's this charge?") requests. */
export const disputeResolveUiFlag = featureFlag(
  "dispute-resolve-ui",
  teamContext,
).boolean(false);
